<script>
  import { createEventDispatcher } from 'svelte';
  import PulseStatusAnim from '../../Common/PulseStatusAnim.svelte';
  import { broadcaster } from './broadcast-store';

  const dispatch = createEventDispatcher();

  export let joinAsGuest = false;
</script>

<div class="controls-container">
  {#if joinAsGuest}
    {#if !$broadcaster.isInitializingPublish}
      <button
        class="pub-btn"
        class:stop={$broadcaster.isBroadcastingAsGuest}
        on:click={!$broadcaster.isBroadcastingAsGuest
          ? dispatch('joinAsGuest')
          : dispatch('leaveAsGuest')}
        >{$broadcaster.isBroadcastingAsGuest ? 'Forlat' : 'Gå live som gjest'}</button
      >
    {:else}
      <div class="status-anim">
        <PulseStatusAnim />
      </div>
    {/if}
  {:else if !joinAsGuest}
    {#if !$broadcaster.isInitializingPublish}
      <button
        class="pub-btn"
        class:stop={$broadcaster.isBroadcasting}
        on:click={!$broadcaster.isBroadcasting ? dispatch('publish') : dispatch('unpublish')}
        >{$broadcaster.isBroadcasting ? 'Stopp' : 'Gå live'}</button
      >
    {:else}
      <div class="status-anim">
        <PulseStatusAnim />
      </div>
    {/if}
  {/if}

  <div class="right-btns">
    <button
      class="btn"
      class:off={!$broadcaster.isCamOn}
      disabled={!$broadcaster.userMediaInitialized || $broadcaster.isInitializingPublish}
      on:click={broadcaster.toggleCamOnOff}
    >
      {#if $broadcaster.isCamOn}
        <span class="material-icons"> videocam </span>
      {:else}<span class="material-icons"> videocam_off </span>{/if}
    </button>
    <button
      class="btn"
      class:off={!$broadcaster.isMicOn}
      disabled={!$broadcaster.userMediaInitialized || $broadcaster.isInitializingPublish}
      on:click={broadcaster.toggleAudioOnOff}
    >
      {#if $broadcaster.isMicOn}
        <span class="material-icons"> mic </span>
      {:else}<span class="material-icons"> mic_off </span>{/if}
    </button>
    <button
      class="desktop btn"
      disabled={!$broadcaster.userMediaInitialized || $broadcaster.isInitializingPublish}
      on:click={() => dispatch('opensettings')}
    >
      <span class="material-icons"> settings </span>
    </button>
    <button
      class="mobile btn"
      disabled={!$broadcaster.userMediaInitialized ||
        $broadcaster.isInitializingPublish ||
        $broadcaster.flippingCam}
      on:click={() => dispatch('flipcam')}
    >
      <span class="material-icons"> flip_camera_ios </span>
    </button>
  </div>
</div>

<style src="./controls.scss"></style>
